<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar title="交易流水" left-text="返回" @click-left="onClickLeft" left-arrow fixed>
        </van-nav-bar>
        <!--导航栏 end-->

        <!-- 内容 start -->
        <div class="page">
            <div class="list">
                <!-- 交易流水 -->
                <div class="list-top">
                    <!-- 时间选择 -->
                    <div style="display: flex;align-items: center;">
                        <!-- 开始时间 -->
                        <div @click="showPopFn()">
                            <div v-if="timeValue">{{ timeValue }}</div>
                            <div v-else>开始时间</div>
                        </div>
                        <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
                            <van-datetime-picker v-model="currentDate" type="date" title="选择日期" @confirm="confirmFn()"
                                @cancel="cancelFn()" />
                        </van-popup>
                        <!-- 横线 -->
                        <div style="margin: 0.2rem;">-</div>
                        <!-- 结束时间 -->
                        <div @click="showPopFn1()">
                            <div v-if="timeValue1">{{ timeValue1 }}</div>
                            <div v-else> 结束时间</div>
                        </div>
                        <van-popup v-model="show1" position="bottom" :style="{ height: '40%' }">
                            <van-datetime-picker v-model="currentDate1" type="date" title="选择日期" @confirm="confirmFn1()"
                                @cancel="cancelFn1()" />
                        </van-popup>
                    </div>
                </div>
            </div>

            <!-- 列表数据 -->
            <div class="list-data">
                <!-- 交易流水 -->
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                    <div v-for="(admin, index) in list" :key="index">
                        <van-cell @click="to_transaction_details(admin.pay_id)">
                            <van-row gutter="20">
                                <van-col span="14">
                                    <van-row gutter="20">
                                        <van-col span="24" class="title_font">{{ admin.trans_subject }}</van-col>
                                        <van-col span="24" class="date_font">{{ admin.trans_oktime }}</van-col>
                                    </van-row>
                                </van-col>
                                <van-col span="6">
                                    <van-row gutter="20">
                                        <van-col span="24" class="title_font">{{ admin.trans_type == "wxpay" ? "微信" :
            (admin.trans_type == "alipay" ? "支付宝" : "云闪付") }}</van-col>
                                        <van-col span="24" class="title_font">￥{{ admin.total_fee }}</van-col>

                                    </van-row>
                                </van-col>
                                <van-col span="4" :class="admin.trans_status == 3 ? 'green_like' : 'green_font'"
                                    class="green_font">{{ admin.trans_status == 3 ? "退款" : "成功" }}</van-col>
                            </van-row>
                        </van-cell>
                    </div>
                </van-list>
            </div>
        </div>
        <!-- 内容 end -->
    </div>
</template>

<script>

export default {
    name: "TransactionFlow", //交易流水
    data() {
        return {
            list: [],
            loading: false,
            finished: false,
            //下拉选择
            value1: 0,
            option1: [],
            //时间选择
            msg: '',
            currentDate: new Date(),
            currentDate1: new Date(),
            changeDate: new Date(),
            show: false, // 用来显示弹出层
            show1: false, // 用来显示弹出层
            timeValue: '',
            timeValue1: "",
            //初始化获取当前时间
            systemTime: "",
            page: 0,
            num: 10,
            // 门店id
            store_id: '',
            store_name: ''
        };
    },
    mounted() {
        this.timeFormat(new Date());
        //初始化获取当前的时间  
        this.addDate();
        //门店信息    
        //    this.tive()
        //    this.theStores() 
    },
    methods: {
        //门店选择
        // outlet(a,b){
        //    this.store_id=a;
        //    this.store_name=b;
        //    this.$refs.item.toggle();
        //     this.page=0;
        //     this.list=[]
        //     this.onLoad() 
        // },
        // 点击下拉菜单全部门店
        // pagex(){
        //     this.store_id="";
        //     this.page=0;
        //     this.list=[];
        //     this.$refs.item.toggle();
        //      this.onLoad() 
        // },
        //全部门店列表
        //    theStores(){
        //              this.$http.get('/wechat/user/get_merchant_list', {
        //             params: {
        //                 merchant_id:window.sessionStorage.getItem("commercialId"),
        //             }
        //         }).then(response => {
        //             console.log(response.data.data);
        //             this.option1=response.data.data

        //         }) 
        //    },
        // 页面初始化的时候确定当前的日期
        addDate() {
            let nowDate = new Date()
            let date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate()
            }
            if (this.$store.state.time != "" && this.$store.state.time1 == "") {
                this.timeValue = this.$store.state.time
                this.timeValue1 = date.year + '-' + date.month + '-' + date.date
            } else if (this.$store.state.time == "" && this.$store.state.time1 != "") {
                this.timeValue = date.year + '-' + date.month + '-' + date.date
                this.timeValue1 = this.$store.state.time1
            } else if (this.$store.state.time != "" && this.$store.state.time1 != "") {
                this.timeValue = this.$store.state.time
                this.timeValue1 = this.$store.state.time1
            } else if (this.$store.state.time == "" && this.$store.state.time1 == "") {
                this.timeValue = date.year + '-' + date.month + '-' + date.date,
                    this.timeValue1 = date.year + '-' + date.month + '-' + date.date
            }

        },


        // 时间选择
        showPopFn() {
            this.show = true;
        },
        showPopFn1() {
            this.show1 = true;
        },
        showPopup() {
            this.show = true;
        },
        showPopup1() {
            this.show = true;
        },
        changeFn() { // 值变化是触发
            this.changeDate = this.currentDate // Tue Sep 08 2020 00:00:00 GMT+0800 (中国标准时间)
        },
        changeFn1() { // 值变化是触发
            this.changeDate = this.currentDate1 // Tue Sep 08 2020 00:00:00 GMT+0800 (中国标准时间)
        },
        confirmFn() { // 确定按钮
            this.timeValue = this.timeFormat(this.currentDate);
            // console.log(this.timeValue);
            this.$store.commit("timer", this.timeValue)
            this.show = false;
            this.page = 0;
            this.list = []
            this.onLoad()
        },
        confirmFn1() { // 确定按钮
            this.timeValue1 = this.timeFormat(this.currentDate1);
            //  console.log(this.timeValue1);
            this.$store.commit("timer1", this.timeValue1)
            this.show1 = false;
            this.page = 0;
            this.list = []
            this.onLoad()

        },
        cancelFn() {
            this.show = false;
        },
        cancelFn1() {
            this.show1 = false;
        },
        timeFormat(time) { // 时间格式化 2019-09-08
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            return year + '-' + month + '-' + day + ''
        },

        // 左侧返回
        onClickLeft() {
            this.$router.push("/StoreHomepage");
        },
        // 右侧icon跳转至订单查询
        onClickRight() {
            // 跳转至订单查询
            this.$router.push('/StoresTransactionSearch');
        },
        // 列表
        onLoad() {
            console.log("111111111111111111111111111111");
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            this.page += 1;
            // if (this.store_id!=null) {
            //     this.tive1()
            // }else{
            this.tive()
            // }
        },
        //根据门店选择发送请求
        //   tive1(){
        //         var that=this
        //          this.$http.get('/wechat/api.order/get_order', {
        //             params: {
        //                 merchant_id:window.sessionStorage.getItem("commercialId"),
        //                 start_date:this.timeValue,
        //                 store_id:this. store_id,
        //                 end_date:this.timeValue1,
        //                 page:this.page,
        //                 num:this.num
        //             }
        //         }).then(response => {
        //             console.log("1");
        //           that.loading=false;
        //       if (response.data.data.length) {
        //            that.list.push(...response.data.data);
        //            that.finished = false;
        //             } else{
        //              that.finished = true;
        //             }

        //         }) 
        //     },
        //根据选择日期去发送请求
        tive() {
            var that = this
            this.$http.get('/wechat/api.order/get_order', {
                params: {
                    merchant_id: window.sessionStorage.getItem("commercialId"),
                    store_id: window.sessionStorage.getItem("store_id"),
                    start_date: this.timeValue,
                    end_date: this.timeValue1,
                    page: this.page,
                    num: this.num
                }
            }).then(response => {
                console.log("1");
                that.loading = false;
                if (response.data.data.length) {
                    that.list.push(...response.data.data);
                    that.finished = false;
                } else {
                    that.finished = true;
                }

            })
        },
        // 跳转至单笔订单明细
        to_transaction_details(pay_id) {
            console.log(pay_id);
            this.$router.push({ path: '/StoresTransactionDetails', query: { jobId: pay_id } })

        },
    },
}
</script>

<style scoped>
.title_font {
    color: #535353;

}

.title_font1 {
    color: #535353;
    position: relative;
    top: 0.33rem;

}

.date_font {
    color: #919191;
}

.green_font {
    color: #4cd964;
    line-height: 48px;
}

.green_like {
    color: red;
    line-height: 48px;
}

.van-menu {
    display: flex;
    justify-content: space-between;
}

#van-menu-item {
    width: 67%;
    display: flex;
    border-right: none;
    z-index: 100;
    /* border: solid 1px red; */

}

.div-hr {
    background-color: white;
    height: 1.27rem;
}

hr {
    margin-top: 0.65rem;
    width: 0.4rem;
    background-color: white;
}

#van-dropdown-menu {

    width: 45%;
    border-left: none;
    /* border: solid 1px red; */
    background-color: white;
}

.page {
    width: 100%;
    height: 200px;
    box-sizing: border-box;
    padding: 16px;
    background-color: rgba(20, 134, 251, 1);
}

.list {
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    height: 40px;
    margin-top: 50px;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-radius: 12px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    border-bottom: 1px solid rgba(215, 215, 215, 1);
}

.list-top {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #333333;
}

.list-data {
    width: 100%;
    height: calc(100vh - 200px);
    overflow-y: auto;
    background-color: #fff;
}

.list-top /deep/ .van-dropdown-menu__bar {
    box-shadow: none !important;
    height: 30px !important;
}

.list-top /deep/ .van-dropdown-menu__title {
    font-size: 12px;
    color: #333333;
    max-width: none;
    max-width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
<style scoped="scoped">
.van-field__control {
    position: relative;
    top: 0.1rem;

}

.starting {
    width: 50%;
    background-color: white;

}

.van-popup {
    overflow-y: hidden !important;
}
</style>